import { Button, Heading, ModalContent, Text } from 'components';
import { FontWeight } from 'commons';
import * as S from './styles';

interface Props {
  finishForm: () => void;
}

export function CompletedModal({ finishForm }: Props) {
  return (
    <ModalContent handleClose={finishForm}>
      <S.Main>
        <Heading as="h5" weight={FontWeight.bold}>
          Formulário preenchido!
        </Heading>

        <S.Wrapper>
          <Text>
            Agradecemos o envio das informações. Estamos realizando uma breve
            validação!
          </Text>

          <Text>Acompanhe os próximos passos na aba de perfil no painel.</Text>

          <Text>Mostraremos lá quando estiver disponível a próxima etapa.</Text>
        </S.Wrapper>

        <Button full onClick={finishForm}>
          Ir para o perfil
        </Button>
      </S.Main>
    </ModalContent>
  );
}
